import { FieldBuilder, FieldDefinition } from '@zendra/shared';
import { LocationService } from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

export const PROPERTYORIGINDESTINATION_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'originLocationId',
    'Entity.PropertyOriginDestination.OriginLocation',
    LocationService,
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'destinationLocationId',
    'Entity.PropertyOriginDestination.DestinationLocation',
    LocationService,
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'propertyLocationId',
    'Entity.PropertyOriginDestination.PropertyLocation',
    LocationService,
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .number('distance', 'Entity.PropertyOriginDestination.Distance')
    .decimal()
    .build(),
  FieldBuilder
    .number('pavedRoadDistance', 'Entity.PropertyOriginDestination.PavedRoadDistance')
    .decimal()
    .build(),
  FieldBuilder
    .number('unPavedRoadDistance', 'Entity.PropertyOriginDestination.UnPavedRoadDistance')
    .decimal()
    .build(),
  FieldBuilder
    .number('tollCount', 'Entity.PropertyOriginDestination.TollCount')
    .build(),
  FieldBuilder
    .checkbox('isTruckAllowed', 'Entity.PropertyOriginDestination.IsTruckAllowed')
    .build(),
  FieldBuilder
    .checkbox('isBitrenAllowed', 'Entity.PropertyOriginDestination.IsBitrenAllowed')
    .build(),
  FieldBuilder
    .checkbox('isCurrent', 'Entity.PropertyOriginDestination.IsCurrent')
    .build(),
  FieldBuilder
    .checkbox('isFuture', 'Entity.PropertyOriginDestination.IsFuture')
    .build(),
  FieldBuilder
    .date('executionDate', 'Entity.PropertyOriginDestination.ExecutionDate')
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.PropertyOriginDestination.IsActive')
    .build(),
];

export const PROPERTYORIGINDESTINATION_CONFIG = {
  entityName: 'PropertyOriginDestination',
  localizationKey: 'Geographic::Entity.PropertyOriginDestination',
  fields: PROPERTYORIGINDESTINATION_FIELDS,
  permission: 'PlanningGeography.PropertyOriginDestinations',
  showInMenu: false,
};